import type { MouseEventHandler } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { memoGeneric } from '@/js/libs/memo/index.ts';

import { Tag } from '../../Elements/Tag/index.tsx';
import { TabWrapper, Title } from './styled.ts';
import type { TabsGroupItemProps } from './types.ts';

interface TabItemProps<TItem extends string> {
  item: TabsGroupItemProps<TItem>;
  active: boolean;
  onTabChange: (id: TItem) => void;
}

export const TabItem = memoGeneric(function TabItem<TItem extends string = string>({ item, active, onTabChange }: TabItemProps<TItem>) {
  const handleClick = useCallbackRef<MouseEventHandler<HTMLDivElement>>(() => {
    onTabChange(item.id);
  });

  const dataTestId = item.dataTestId || `${item.id}-tab`;

  if (item.hidden) {
    return null;
  }

  return (
    <TabWrapper $active={active} onClick={handleClick} data-testid={dataTestId} data-active={active}>
      <Title $active={active}>{item.title}</Title>
      {item.label && <Tag title={item.label} />}
    </TabWrapper>
  );
});
